// public/js/features/announcements/whats-new-modal.js
// The "What's new" modal shown on load when a user has unread posts. Shows all
// unread posts in one scrollable dialog (newest first) and marks them read when
// closed. See docs/announcements.md.
import { markAnnouncementsRead } from './api.js';
import { renderBlocks, announcementDate } from './render.js';

const esc = (s) => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

// posts: array of unread, published posts (newest first). onClosed: optional cb.
export function openWhatsNewModal(posts, onClosed) {
  if (!posts || !posts.length) return;
  document.getElementById('whatsNewModal')?.remove();

  const multi = posts.length > 1;
  const body = posts.map((p, i) => `
    <article class="${i > 0 ? 'pt-3 mt-3 border-top' : ''}">
      <div class="d-flex justify-content-between align-items-baseline mb-1">
        <h4 class="h5 mb-0">${esc(p.title)}</h4>
        <span class="badge text-bg-light border ms-2 flex-shrink-0">#${p.seq}</span>
      </div>
      <div class="text-muted small mb-2">${announcementDate(p)}</div>
      <div class="announcement-body">${renderBlocks(p.blocks)}</div>
    </article>`).join('');

  const html = `
    <div class="modal fade" id="whatsNewModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="fa-solid fa-bullhorn me-2 text-primary"></i>What's new${multi ? ` <span class="badge text-bg-primary ms-1">${posts.length}</span>` : ''}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">${body}</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Got it</button>
          </div>
        </div>
      </div>
    </div>`;
  document.body.insertAdjacentHTML('beforeend', html);
  const el = document.getElementById('whatsNewModal');
  const modal = new bootstrap.Modal(el);
  el.addEventListener('hidden.bs.modal', async () => {
    el.remove();
    await markAnnouncementsRead();
    onClosed?.();
  }, { once: true });
  modal.show();
}
